import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};

const faqs = [
  {
    question: "Does it really cost anything?",
    answer: "No — our basics class is 100% free for students, from registration through every class. We do offer some specialized paid sessions to help us fundraise every now and then though!"
  },
  {
    question: "What do we need to join a class?",
    answer: "Just a laptop or computer with an internet connection and a web browser. Our lessons run in the browser (no software installs), so a Chromebook works fine."
  },
  {
    question: "Are classes live, or self-paced videos?",
    answer: "Classes are live and instructor-led over video call, run by our expert instructors. A parent or guardian doesn't need to sit in — students join the session directly."
  },
  {
    question: "What age or grade level is this for?",
    answer: "We offer pathways for elementary (grades 3–5), middle school (grades 6–8), and high school (grades 9–12), each with age-appropriate projects and curriculum."
  },
  {
    question: "Do I need any prior coding experience?",
    answer: "No prior experience is required. Lessons start from the fundamentals and build up through guided, project-based exercises."
  }
];

export const FaqSection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div aria-hidden className="absolute top-0 left-0 right-0 h-px bg-border/90" />
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="max-w-3xl mx-auto space-y-16"
        >
          <motion.div variants={item} className="text-center space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-foreground">
              What to <span className="text-primary">Expect</span>
            </h2>
            <motion.div
              variants={item}
              className="h-0.5 bg-gradient-to-r from-primary/30 to-transparent w-24 mx-auto"
            />
            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
              A few common questions before you sign up.
            </p>
          </motion.div>

          <motion.div variants={item}>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left text-lg font-medium text-foreground">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed text-base">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
